/* eslint-disable */

import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
Vue.use(Vuesax)


// Theme Configurations
import '../themeConfig.js'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'

//plugins (Exception handling)
import './plugins';


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'

// i18n
import i18n from './i18n/i18n'


// Vuexy Admin Filters
import './filters/filters'


// Tableau
import 'vue-tableau'

import './validation/vee-validate'

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)

import AuthService from '@/app/shared/services/authentication/auth.service';

import {axiosWebApiInstance} from '@/app/shared/services/http-client/webApi.axios';
import {axiosGraphApiInstance} from '@/app/shared/services/http-client/graphApi.axios';
import {axiosPowerBIApiInstance} from '@/app/shared/services/http-client/powerBiApi.axios';

import dialogPlugin from './app/shared/services/dialog-plugin';
import errorPlugin from './app/shared/services/error-plugin';
import systemUnitsPlugin from './plugins/systemUnits.js';
import cqrsApiPlugin from './app/shared/services/cqrsApi-plugin';

import featureFlagsService from '@/app/shared/services/featureFlagsService.js'

// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

import './assets/scss/bootstrap-tooltip.scss';
import './assets/scss/list.scss';
import { VBTooltip } from 'bootstrap-vue'
// Note: Vue automatically prefixes the directive name with 'v-'
Vue.directive('b-tooltip', VBTooltip)

// Feather font icon
require('./assets/css/iconfont.css')
// require('./assets/css/opensansfont.css')

Vue.config.productionTip = false

Vue.use(dialogPlugin);
Vue.use(errorPlugin);
Vue.use(cqrsApiPlugin);
Vue.use(systemUnitsPlugin);

Vue.use({
  install(vue) {
    // eslint-disable-next-line
    vue.prototype.$auth = new AuthService();
      // Required Params
  }
});

Vue.use({
  install(vue) {
    // eslint-disable-next-line
    vue.prototype.$webApi = axiosWebApiInstance;
      // Required Params
  }
});

Vue.use({
  install(vue) {
    // eslint-disable-next-line
    vue.prototype.$graphApi = axiosGraphApiInstance;
  }
});

import axios from './axios.js'
Vue.prototype.$http = axios

// mock
import './app/abc/fake-db/index.js'

Vue.use({
  install(vue) {
    // eslint-disable-next-line
    vue.prototype.$powerBiApi = axiosPowerBIApiInstance;
  }
});


new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  beforeCreate() {
    return this.$auth.initialize().then(() => {
      if (!this.$auth.isAuthenticated()) {
        console.log('Not authenticated, redirecting to login');
        this.$auth.loginRedirect();
      } else {
        return Promise.all([
          this.$store.dispatch("fetchAllAuthorizedProjects"),
          this.$store.dispatch("fetchConfigurations"),
          featureFlagsService.init()
        ]).then(() => {
          this.$store.dispatch("appBootstrapCompleted");
        })
      }
    });
  },
  async created() {
    // if no project has been founded in local storage, select the first one on which user do get access
    if(this.$store.state.projectId === null ) {
      var userProjects = this.$store.state.authorizedProjects;
      if(userProjects.length > 0){
        this.$store.dispatch("updateProjectId", userProjects[0].projectId);
      }
    }
  }
}).$mount('#app')
